// Simple rename modal for channels and group DMs.
export const ChatRenameModal = {
  show: (el, s) => !!(s.root?.renameModal?.open),
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  zIndex: 10000,
  align: 'center center',
  background: 'black.5',

  onClick: (e, el, s) => {
    if (e.target === el.node) s.root.update({ renameModal: { open: false } })
  },

  Card: {
    flow: 'y',
    gap: 'A',
    padding: 'B',
    round: 'A',
    background: 'overlayStrong',
    borderWidth: '1px',
    borderColor: 'line',
    borderStyle: 'solid',
    width: 'H',
    maxWidth: '90vw',
    boxShadow: '0 16px 48px -8px rgba(0, 0, 0, 0.6)',

    Title: {
      tag: 'h3',
      margin: '0',
      fontSize: 'A',
      fontWeight: '600',
      color: 'title',
      text: 'Rename'
    },

    Input: {
      tag: 'input',
      type: 'text',
      padding: 'Z A',
      round: 'Z',
      borderWidth: '1px',
      borderColor: 'line',
      borderStyle: 'solid',
      background: 'document',
      color: 'title',
      fontSize: 'Z2',
      fontFamily: 'inherit',
      value: (el, s) => s.root?.renameModal?.currentName || '',
      onInput: (e, el, s) => {
        s.root.update({
          renameModal: { ...s.root.renameModal, currentName: e.target.value }
        })
      },
      onKeydown: (e, el, s) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          const rm = s.root?.renameModal
          if (rm?.currentName?.trim() && rm?.channelId) {
            el.call('renameChannel', rm.channelId, rm.currentName.trim())
            s.root.update({ renameModal: { open: false } })
          }
        }
        if (e.key === 'Escape') {
          s.root.update({ renameModal: { open: false } })
        }
      },
      onCreate: (el) => {
        requestAnimationFrame(() => {
          if (el.node) { el.node.focus(); el.node.select() }
        })
      }
    },

    Actions: {
      flow: 'x',
      gap: 'Z',
      align: 'center right',

      CancelBtn: {
        extends: 'Button',
        theme: 'secondary',
        text: 'Cancel',
        onClick: (e, el, s) => s.root.update({ renameModal: { open: false } })
      },
      SaveBtn: {
        extends: 'Button',
        theme: 'primary',
        text: 'Save',
        onClick: (e, el, s) => {
          const rm = s.root?.renameModal
          if (rm?.currentName?.trim() && rm?.channelId) {
            el.call('renameChannel', rm.channelId, rm.currentName.trim())
            s.root.update({ renameModal: { open: false } })
          }
        }
      }
    }
  }
}
